import React from "react";
import { LegalPage } from "./legal/LegalPage";

const Garantias = () => <LegalPage namespace="legalGarantias" />;

export default Garantias;
